export const AI_ANALYTICS_PATH = '/ai-analytics';

export const ACTIVE_THREAD_STORAGE_KEY = 'aiAnalytics.activeThreadId';
export const SELECTED_CHART_STORAGE_KEY = 'aiAnalytics.selectedChartId';

export const DEFAULT_THREAD_TITLE = 'New conversation';
export const AUTO_TITLE_WORD_COUNT = 6;
export const AUTO_TITLE_MAX_CHARS = 60;

export const CHART_POLL_INTERVAL_MS = 2000;
export const CHART_MAX_POLL_ATTEMPTS = 60;
export const ASK_FAST_POLL_MS = 2000;
export const ASK_SLOW_POLL_MS = 5000;
export const ASK_FAST_POLL_WINDOW_MS = 60 * 1000;
export const ASK_POLL_DEADLINE_MS = 40 * 60 * 1000;
export const OP_RESUME_POLL_MS = 5000;
export const OP_RESUME_DEADLINE_MS = 20 * 60 * 1000;

export const FINISHED_STATUSES = ['finished', 'succeeded'];
export const FAILED_STATUSES = ['failed', 'stopped'];
export const REFUSED_STATUS = 'refused';

export const ASK_OUTCOMES = {
  FINISHED: 'finished',
  FAILED: 'failed',
  REFUSED: 'refused'
};

export const ASK_PHASES = {
  PENDING: 'pending',
  REASONING: 'reasoning',
  GENERATING: 'generating',
  VALIDATING: 'validating',
  EXECUTING: 'executing',
  FINISHED: 'finished'
};

export const MESSAGE_ROLES = {
  USER: 'user',
  ASSISTANT: 'assistant'
};

export const FEEDBACK_RATINGS = {
  UP: 'UP',
  DOWN: 'DOWN'
};

export const FEEDBACK_COMMENT_MAX_LENGTH = 2000;

export const OP_KINDS = {
  GENERATE_CHART: 'generate-chart',
  REFINE_CHART: 'refine-chart',
  REFRESH_DATA: 'refresh-data'
};

export const OP_RUNNING_LABELS = {
  [OP_KINDS.GENERATE_CHART]: 'Generating chart…',
  [OP_KINDS.REFINE_CHART]: 'Refining chart…',
  [OP_KINDS.REFRESH_DATA]: 'Refreshing data…'
};

export const OP_RUNNING_FALLBACK_LABEL = 'Working…';

export const OP_DONE_LABELS = {
  [OP_KINDS.GENERATE_CHART]: 'Done — the chart is ready.',
  [OP_KINDS.REFINE_CHART]: 'Done — the chart was refined.',
  [OP_KINDS.REFRESH_DATA]: 'Done — the data was refreshed.'
};

export const OP_DONE_FALLBACK_LABEL = 'Done — the operation completed.';

export const OP_FAILED_LABELS = {
  [OP_KINDS.GENERATE_CHART]: 'Chart generation failed.',
  [OP_KINDS.REFINE_CHART]: 'Chart refinement failed.',
  [OP_KINDS.REFRESH_DATA]: 'Data refresh failed.'
};

export const OP_FAILED_FALLBACK_LABEL = 'The operation failed.';

export const INSTRUCTION_VISIBILITY = {
  USER: 'USER',
  GLOBAL: 'GLOBAL'
};

export const INSTRUCTION_WIRE_DEFAULTS = {
  is_default: true,
  scope: 'sql'
};

export const VEGA_LITE_CHART_KEYS = [
  'mark',
  'encoding',
  'layer',
  'hconcat',
  'vconcat',
  'concat',
  'repeat',
  'facet',
  'spec'
];

export const ASK_REFUSED_FALLBACK_MESSAGE =
  'I can only answer questions about the clinical-research analytics data. Try asking about that data.';
export const ASK_FAILED_FALLBACK_MESSAGE = 'Something went wrong while processing your question. Please try again.';
export const ASK_NO_SQL_MESSAGE =
  'I could not generate SQL for this question. Try rephrasing or asking about specific tables/metrics.';
export const ASK_TIMED_OUT_MESSAGE = 'The question timed out before a result was ready. Please try asking it again.';
export const ASK_PROCESS_FAILED_MESSAGE = 'Failed to process question';
export const CHART_NOT_APPLIED_MESSAGE =
  'The refinement could not be applied as a chart. Try rewording it (e.g. "use a bar chart" or "color by region").';
export const CHART_FAILED_FALLBACK_MESSAGE = 'Chart generation failed';
export const THREAD_DELETE_FAILED_MESSAGE = 'Failed to delete thread';
export const FEEDBACK_FAILED_MESSAGE = 'Failed to save your feedback';
export const THREAD_DELETE_BLOCKED_MESSAGE =
  "This thread can't be deleted because charts were created from its messages. Delete those charts first.";
